import { baseApi } from "@/services/baseApi";
import {
  GetRecordResponse,
  MutateRecordArgs,
  QueryRecordArgs,
  UpdateRecordResponse,
} from "@/types/types";
import { Record } from "@/components/record/types/record";

export const recordApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    updateRecord: build.mutation<
      UpdateRecordResponse,
      MutateRecordArgs<Record>
    >({
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      query: ({ revision, ...body }) => ({
        url: `/back-fabrica-record/records`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, args) => [
        { type: "Record", id: args.expediente_id },
      ],
    }),
    getRecord: build.query<GetRecordResponse<Record>, QueryRecordArgs>({
      query: (variables) => ({
        url: `/back-fabrica-record/records/${variables.expediente_id}`,
      }),
      providesTags: (_result, _error, args) => [
        { type: "Record", id: args.expediente_id },
      ],
    }),
    getRecords: build.query<Array<string>, void>({
      query: () => ({ url: `/back-fabrica-record/records` }),
      providesTags: () => [{ type: "Records" }],
    }),
    getRecordSchema: build.query<{ schema: any; revision: string }, void>({
      query: () => ({ url: `/back-fabrica-record/records/schema` }),
      providesTags: ["Schema"],
    }),
  }),
});

export const {
  useUpdateRecordMutation,
  useGetRecordQuery,
  useGetRecordSchemaQuery,
  useLazyGetRecordSchemaQuery,
} = recordApi;
